import { getVariantsMeta } from './variant-display-prices';

export function enableBuyNowButton(variant: Variant): void {
  const buyNowButton = document.querySelector('#buy-now-button');
  if (!variant.available) {
    buyNowButton?.setAttribute('disabled', 'disabled');
  } else {
    buyNowButton?.removeAttribute('disabled');
  }
}
export type Variant = {
  id: number;
  sku: string;
  price: number;
  compare_at_price: number;
  available: boolean;
  featured_image: {
    src: string;
    variant_ids: number[];
    [key: string]: string | number | number[];
  };
  [key: string]: any;
  option_name?: string;
};

export function updateFeaturesList(
  variant: Variant,
  featureType: string
): void {
  const variantsMeta = getVariantsMeta('#product-variants-meta');
  const currentVariantMeta = variantsMeta[variant.id];

  if (featureType === 'health') {
    const productFeatures = document.querySelector('#product-features');
    if (!productFeatures) {
      return;
    }
    const healthIncluded =
      currentVariantMeta.health_included === 'true'
        ? 'health-included'
        : 'health-notincluded';

    productFeatures.className = productFeatures.className.replace(
      /product-features--([^\s]+)/,
      ''
    );
    productFeatures.classList.add(`product-features--${healthIncluded}`);
  }

  const featuresList = document.querySelector(
    `.product-features__list--${featureType}`
  );

  if (!featuresList || !(featuresList instanceof HTMLElement)) {
    return;
  }

  const featuresContainer = document.querySelector(
    `.product-features__${featureType}-list`
  );

  if (!featuresContainer || !(featuresContainer instanceof HTMLElement)) {
    return;
  }

  const featuresListItems =
    featureType === 'health'
      ? currentVariantMeta?.health_features
      : currentVariantMeta?.features;

  if (!featuresListItems || featuresListItems === '') {
    featuresContainer.style.display = 'none';
    return;
  }

  const listItemsHTML = featuresListItems
    .map((item: string) => '<li>' + item + '</li>')
    .join('');

  featuresContainer.style.display = 'block';
  featuresList.innerHTML = listItemsHTML;
}
